<template>
    <div class="title">
        <a-row type="flex">
            <a-col class="avatar-container">
                <a-avatar shape="square" :size="96" :src="avatar" />
            </a-col>
            <a-col flex="auto">
                <a-row class="title-main">
                    <a-col>
                        <h2 class="username">{{ name }}</h2>
                        <span class="uid">uid: {{ id }}</span>
                    </a-col>
                    <a-col v-if="canFollow">
                        <a-button v-if="hasFollow" type="dashed" title="取消关注" @click="follow(false)">
                            已关注
                        </a-button>
                        <a-button v-else type="primary" icon="plus" @click="follow(true)">
                            关注
                        </a-button>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: [ 'name', 'avatar', 'id', 'hasFollow', 'canFollow' ],
    methods: {
        follow(opt) {
            this.$emit("follow", opt);
        }
    }
}
</script>

<style lang="less" scoped>
.title {
    padding: 10px;
}
.avatar-container {
    width: 200px;
    text-align: center;
}
.title-main {
    padding: 16px 24px;
}
.username {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    display : inline;
}
.uid {
    margin: 5px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
}
@media screen and (max-width: 600px) {
    .avatar-container {
        width: 100%;
    }
    .title-main {
        text-align: center;
    }
}
</style>